export default class extends Controller {
  static targets = ["companySelect", "projectSelect"]

  connect() {
    if (this.hasCompanySelectTarget) {
      App.DynamicSelect.initEl(this.companySelectTarget)
      App.DynamicSelect.onChange(this.companySelectTarget, this.updateProjectSelect.bind(this))
    }
    App.DynamicSelect.initComplex(this.projectSelectTarget)
  }

  updateProjectSelect() {
    App.DynamicSelect.disable(this.projectSelectTarget)
    App.DynamicSelect.setValue(this.projectSelectTarget, null)
    if (this.companyIDs.length > 0) {
      App.DynamicSelect.setSelect2DataAttribute(this.projectSelectTarget, "select2-ajax-url", this.filteredProjectsURL())
      App.DynamicSelect.enable(this.projectSelectTarget)
    }
  }

  filteredProjectsURL() {
    return this.data.get("projects-for-select-url").replace("COMPANY_IDS", this.companyIDs)
  }

  get companyIDs() {
    return App.DynamicSelect.getValue(this.companySelectTarget)
  }

  set projectIDs(value) {
    return App.DynamicSelect.setValue(this.projectSElectTarget, value)
  }
}



// WEBPACK FOOTER //
// ./app/components/filters/assets/javascript/filters-activity-filter-form-controller.js